export default __webpack_public_path__ + "e737dd99bc5e63a59a580491a16e500a.svg";